/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Description_LabelInputs */

const en_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description/Title`)
};

const fr_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description/Titre`)
};

const de_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung/Titel`)
};

const it_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione/Titolo`)
};

const ru_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание/Название`)
};

const es_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción/Título`)
};

const zh_cn2_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述/标题`)
};

const ja_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明/タイトル`)
};

const hi_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण/शीर्षक`)
};

const pt_pt2_image_export_description_label = /** @type {(inputs: Image_Export_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição/Título`)
};

/**
* | output |
* | --- |
* | "Description/Title" |
*
* @param {Image_Export_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_description_label = /** @type {((inputs?: Image_Export_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_description_label(inputs)
	if (locale === "de") return de_image_export_description_label(inputs)
	if (locale === "it") return it_image_export_description_label(inputs)
	if (locale === "ru") return ru_image_export_description_label(inputs)
	if (locale === "es") return es_image_export_description_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_description_label(inputs)
	if (locale === "ja") return ja_image_export_description_label(inputs)
	if (locale === "hi") return hi_image_export_description_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_description_label(inputs)
	return en_image_export_description_label(inputs)
});